/** Y-axis aggregation options for chart builder. */
export const METRIC_AGGREGATIONS = Object.freeze([
  { id: 'count', label: 'Count', shortLabel: 'Count' },
  { id: 'sum', label: 'Sum', shortLabel: 'Sum' },
  { id: 'avg', label: 'Average', shortLabel: 'Avg' },
  { id: 'min', label: 'Minimum', shortLabel: 'Min' },
  { id: 'max', label: 'Maximum', shortLabel: 'Max' },
]);

export const NUMERIC_KEY_TYPES = Object.freeze([
  'NUMBER',
  'INT',
  'INTEGER',
]);

export const AGGREGATABLE_KEY_TYPES = Object.freeze([
  'INT',
  'BOOLEAN',
]);

export function aggregationNeedsMeasureField(aggregation) {
  return Boolean(aggregation && aggregation !== 'count');
}

export function getAggregationOption(aggregation) {
  return METRIC_AGGREGATIONS.find((item) => item.id === aggregation) || METRIC_AGGREGATIONS[0];
}

export default METRIC_AGGREGATIONS;
